<template>
  <main class="login-page">
    <div class="login-grid" aria-hidden="true"></div>

    <section class="login-card" aria-labelledby="login-title">
      <header class="brand-header">
        <img class="brand-logo" src="/brand-logo.png" alt="优势探索 Advantages Exploring" />
        <h1 id="login-title">优势探索</h1>
        <p class="brand-en">ADVANTAGES EXPLORING</p>
        <p class="brand-subtitle">团建导航 · 管理后台</p>
      </header>

      <div class="card-divider"></div>

      <div class="form-section">
        <h2>账号登录</h2>
        <el-form
          ref="lform"
          class="login-form"
          :model="loginform"
          :rules="rules"
          label-position="top"
          @keyup.enter.native="login"
        >
          <el-form-item label="用户名" prop="name">
            <el-input
              name="name"
              v-model="loginform.name"
              placeholder="请输入用户名"
              autocomplete="username"
              autofocus
            ></el-input>
          </el-form-item>

          <el-form-item label="密码" prop="pass">
            <el-input
              name="password"
              type="password"
              v-model="loginform.pass"
              placeholder="请输入密码"
              autocomplete="current-password"
              show-password
            ></el-input>
          </el-form-item>

          <el-button
            class="login-button"
            type="primary"
            :loading="submitting"
            @click="login"
          >登录</el-button>
        </el-form>

        <router-link class="home-link" to="/">返回官网首页</router-link>
      </div>
    </section>

    <p class="platform-note">团队效能评估与数据分析平台</p>
  </main>
</template>

<script>
export default {
  data() {
    return {
      submitting: false,
      loginform: {
        name: "",
        pass: ""
      },
      rules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        pass: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 5,
            max: 20,
            message: "密码长度在 5 到 20 个字符",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    login() {
      if (this.submitting) return;

      this.$refs.lform.validate(valid => {
        if (!valid) return;

        this.submitting = true;
        this.$http
          .post("User/Login", {
            username: this.loginform.name,
            password: this.loginform.pass
          })
          .then(response => {
            this.submitting = false;
            if (response.data.bRes) {
              this.$message({
                message: "登录成功",
                type: "success"
              });
              sessionStorage.setItem("token", response.data.Ticket);
              this.$router.push({ name: "admin" });
            } else {
              this.$message({
                message: "账号或密码错误，请重新输入",
                type: "error"
              });
            }
          })
          .catch(() => {
            this.submitting = false;
            this.$message({
              message: "网络连接异常，请稍后重试",
              type: "error"
            });
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.login-page {
  position: relative;
  width: 100%;
  min-height: 100vh;
  padding: 52px 20px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: #172238;
  background:
    radial-gradient(circle at 12% 12%, rgba(48, 91, 190, .22), transparent 32%),
    radial-gradient(circle at 88% 88%, rgba(74, 104, 178, .16), transparent 36%),
    linear-gradient(135deg, #0d172c 0%, #0a1325 55%, #111f3a 100%);
}

.login-grid {
  position: absolute;
  inset: 0;
  opacity: .28;
  background-image:
    linear-gradient(rgba(255, 255, 255, .035) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, .035) 1px, transparent 1px);
  background-size: 72px 72px;
  mask-image: linear-gradient(to bottom, rgba(0,0,0,.7), transparent 92%);
}

.login-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 630px;
  padding: 46px 60px 36px;
  border: 1px solid rgba(255,255,255,.78);
  border-radius: 28px;
  background: rgba(255, 255, 255, .985);
  box-shadow: 0 30px 80px rgba(0, 7, 24, .38);
}

.brand-header { text-align: center; }
.brand-logo {
  width: 190px;
  height: 88px;
  margin: 0 auto 12px;
  display: block;
  object-fit: contain;
}
.brand-header h1 {
  color: #111c31;
  font-size: 38px;
  line-height: 1.2;
  letter-spacing: 5px;
}
.brand-en {
  margin-top: 12px;
  color: #91a0b7;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 4px;
}
.brand-subtitle {
  margin-top: 18px;
  color: #65758d;
  font-size: 17px;
}
.card-divider {
  height: 1px;
  margin: 34px 0 36px;
  background: #e1e6ef;
}
.form-section h2 {
  margin-bottom: 26px;
  color: #34435b;
  font-size: 22px;
  font-weight: 700;
}
.login-form ::v-deep .el-form-item { margin-bottom: 23px; }
.login-form ::v-deep .el-form-item__label {
  padding: 0 0 9px;
  color: #34435b;
  font-size: 16px;
  line-height: 1.4;
}
.login-form ::v-deep .el-input__inner {
  height: 58px;
  padding: 0 18px;
  border-color: #d8e0ec;
  border-radius: 11px;
  color: #1e2b40;
  font-size: 16px;
  background: #fff;
  transition: border-color .2s, box-shadow .2s;
}
.login-form ::v-deep .el-input__inner::placeholder { color: #a5b0c1; }
.login-form ::v-deep .el-input__inner:hover { border-color: #9db2df; }
.login-form ::v-deep .el-input__inner:focus {
  border-color: #3267e8;
  box-shadow: 0 0 0 3px rgba(50, 103, 232, .13);
}
.login-button {
  width: 100%;
  height: 58px;
  margin-top: 2px;
  border: 0;
  border-radius: 11px;
  font-size: 18px;
  letter-spacing: 5px;
  background: linear-gradient(100deg, #315fda, #326ef0);
  box-shadow: 0 12px 25px rgba(49, 103, 225, .22);
  transition: transform .2s, box-shadow .2s, filter .2s;
}
.login-button:hover,
.login-button:focus {
  transform: translateY(-1px);
  filter: brightness(1.04);
  box-shadow: 0 15px 30px rgba(49, 103, 225, .3);
}
.home-link {
  width: fit-content;
  margin: 22px auto 0;
  display: block;
  color: #6d7d94;
  font-size: 14px;
  text-decoration: none;
  transition: color .2s;
}
.home-link:hover { color: #315fda; }
.platform-note {
  position: relative;
  z-index: 1;
  margin-top: 28px;
  color: rgba(176, 188, 210, .62);
  font-size: 14px;
  letter-spacing: 1px;
}

@media (max-width: 640px) {
  .login-page { min-height: 100dvh; padding: 24px 16px; justify-content: flex-start; }
  .login-card { max-width: 460px; padding: 30px 24px 26px; border-radius: 22px; }
  .brand-logo { width: 156px; height: 70px; margin-bottom: 8px; }
  .brand-header h1 { font-size: 31px; }
  .brand-en { font-size: 12px; letter-spacing: 2.5px; }
  .brand-subtitle { margin-top: 13px; font-size: 15px; }
  .card-divider { margin: 25px 0; }
  .form-section h2 { margin-bottom: 20px; font-size: 20px; }
  .login-form ::v-deep .el-input__inner,
  .login-button { height: 52px; }
  .platform-note { margin-top: 20px; text-align: center; }
}

@media (max-height: 760px) and (min-width: 641px) {
  .login-page { padding: 28px 20px; justify-content: flex-start; }
  .login-card { padding-top: 30px; padding-bottom: 28px; }
  .brand-logo { height: 66px; margin-bottom: 4px; }
  .brand-header h1 { font-size: 32px; }
  .brand-subtitle { margin-top: 10px; }
  .card-divider { margin: 22px 0; }
  .form-section h2 { margin-bottom: 16px; }
  .login-form ::v-deep .el-form-item { margin-bottom: 16px; }
}

@media (prefers-reduced-motion: reduce) {
  .login-button,
  .home-link,
  .login-form ::v-deep .el-input__inner { transition: none; }
  .login-button:hover,
  .login-button:focus { transform: none; }
}
</style>
